import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnDestroy, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-shell {
  background: radial-gradient(circle at 78% -12%, rgba(16, 185, 129, 0.08), transparent 34rem), #f6f9f7;
}

.app-shell-glow {
  background: linear-gradient(90deg, rgba(236, 253, 245, 0.72), rgba(248, 250, 252, 0.3));
}

.app-sidebar {
  background: rgba(255, 255, 255, 0.96);
  border-right: 1px solid rgba(203, 213, 225, 0.72);
  box-shadow: 8px 0 28px rgba(15, 23, 42, 0.035);
}

.app-sidebar-inner {
  scrollbar-color: #d7e3dd transparent;
  scrollbar-width: thin;
}

.app-sidebar-mobile {
  border: 1px solid rgba(255, 255, 255, 0.76);
}

.app-content-shell {
  background: transparent;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}

.app-topbar {
  background: rgba(246, 249, 247, 0.88);
  border-bottom: 1px solid rgba(203, 213, 225, 0.68);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.025);
}

.top-workspace-nav {
  border: 1px solid rgba(203, 213, 225, 0.78);
  box-shadow: 0 7px 20px rgba(15, 23, 42, 0.045);
}

.business-workspace-link {
  align-items: center;
}

.business-workspace-nav-icon {
  align-items: center;
  display: inline-flex;
  flex: 0 0 1rem;
  font-size: 0.9375rem;
  height: 1rem;
  justify-content: center;
  line-height: 1;
  position: relative;
  top: -0.03125rem;
  width: 1rem;
}

.top-search input {
  border-color: rgba(148, 163, 184, 0.5);
  border-radius: 0.75rem;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.035);
}

.top-search input:hover {
  border-color: rgba(5, 150, 105, 0.42);
}

:host ::ng-deep input[type=date]:not(:disabled):not(:read-only):not([data-auto-date=true]) {
  cursor: pointer;
}

:host ::ng-deep input[type=date]:not(:disabled):not(:read-only):not([data-auto-date=true])::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 1;
}

:host ::ng-deep input[type=date]:disabled,
:host ::ng-deep input[type=date]:read-only,
:host ::ng-deep input[type=date][data-auto-date=true] {
  cursor: default;
}

@media (max-width: 1023px) {
  .app-topbar-content {
    padding-top: 0.125rem;
  }
  .top-workspace-nav {
    padding-right: 0.375rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .top-search input {
    transition: none;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit, OnDestroy {
    public dashboardSearchQuery: string = '';

    private dashboardWorkspaces: string[] = [
        'dashboard',
        'cases',
        'clients',
        'favoriteClients',
        'standardQuotes',
        'businessManagement',
        'ipMarket',
        'adminSupport',
        'accessStatus',
        'intakeConsultations',
        'intakeConsultationDetail',
        'caseDetail'
    ];
    private sessionCheckTimer: any = null;
    private sessionCheckRunning: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.redirectForRequiredPasswordChange()) return;
        this.sessionCheckTimer = window.setInterval(() => this.checkActiveSession(), 15000);
    }

    public ngOnDestroy() {
        if (this.sessionCheckTimer !== null) {
            window.clearInterval(this.sessionCheckTimer);
            this.sessionCheckTimer = null;
        }
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
    }

    @HostListener('document:click', ['$event'])
    public openSystemDatePicker(event: any) {
        if (event?.__systemDatePickerHandled) return;
        const input = event?.target;
        if (!input || String(input.tagName || '').toLowerCase() !== 'input' || String(input.type || '').toLowerCase() !== 'date') return;
        if (input.disabled || input.readOnly || input.getAttribute?.('data-auto-date') === 'true') return;
        event.__systemDatePickerHandled = true;
        try {
            input.focus({ preventScroll: true });
            if (typeof input.showPicker === 'function') input.showPicker();
        } catch (error) {
            input.focus();
        }
    }

    @HostListener('document:visibilitychange')
    public async checkSessionWhenVisible() {
        if (!document.hidden) await this.checkActiveSession();
    }

    @HostListener('window:dashboard:workspace-changed')
    @HostListener('window:popstate')
    public async refreshActiveState() {
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public dashboardUrl(workspace: string) {
        if (workspace === 'dashboard') return '/dashboard';
        return `/dashboard?workspace=${workspace}`;
    }

    public async openDashboardWorkspace(workspace: string, event: any) {
        if (event?.button !== 0 || event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey) return;
        if (location.pathname !== '/dashboard') return;

        event.preventDefault();
        const target = this.normalizeWorkspace(workspace) || 'dashboard';
        history.pushState({ workspace: target }, '', this.dashboardUrl(target));
        window.dispatchEvent(new CustomEvent('dashboard:navigate', { detail: { workspace: target } }));
        await this.service.render();
    }

    public async openDashboardCategory(category: string, event: any) {
        if (event?.button !== 0 || event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey) return;
        if (location.pathname !== '/dashboard') return;

        event.preventDefault();
        window.dispatchEvent(new CustomEvent('dashboard:category', { detail: { category } }));
        await this.service.render();
    }

    public async updateDashboardSearch(event: any) {
        this.dashboardSearchQuery = String(event?.target?.value || '');
        this.dispatchDashboardSearch();
        await this.service.render();
    }

    public async focusDashboardSearch() {
        this.dispatchDashboardSearch();
        await this.service.render();
    }

    public topWorkspaceClass(workspace: string) {
        const current = this.currentDashboardWorkspace();
        const active = current === workspace || (workspace === 'cases' && current === 'caseDetail');
        const baseClass = 'inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-md px-3 text-[13px] font-medium transition';

        if (active) {
            return `${baseClass} bg-emerald-900 text-white`;
        }

        return `${baseClass} text-slate-600 hover:bg-emerald-50 hover:text-emerald-950`;
    }

    public topCategoryClass(category: string) {
        const params = new URLSearchParams(location.search);
        const active = this.currentDashboardWorkspace() === 'cases' && params.get('category') === category;
        const baseClass = 'inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-md px-3 text-[13px] font-medium transition';
        return active
            ? `${baseClass} bg-emerald-900 text-white`
            : `${baseClass} text-slate-600 hover:bg-emerald-50 hover:text-emerald-950`;
    }

    private dispatchDashboardSearch() {
        if (location.pathname !== '/dashboard') return;
        window.dispatchEvent(new CustomEvent('dashboard:search', { detail: { query: this.dashboardSearchQuery } }));
    }

    private currentDashboardWorkspace() {
        if (location.pathname !== '/dashboard') return '';
        const params = new URLSearchParams(location.search);
        if (params.has('workspace')) {
            return this.normalizeWorkspace(params.get('workspace') || '');
        }

        const fromHash = this.normalizeWorkspace(location.hash.replace('#', ''));
        return fromHash || 'dashboard';
    }

    private normalizeWorkspace(workspace: string) {
        if (this.dashboardWorkspaces.indexOf(workspace) >= 0) return workspace;
        return '';
    }

    private async checkActiveSession() {
        if (this.sessionCheckRunning) return;
        this.sessionCheckRunning = true;
        try {
            await this.service.auth.init();
            if (this.service.auth.check()) {
                this.redirectForRequiredPasswordChange();
                return;
            }

            const returnTo = `${location.pathname}${location.search}${location.hash}`;
            const params = new URLSearchParams({ returnTo });
            if (this.service.auth.reason === 'SESSION_REPLACED') {
                params.set('reason', 'session_replaced');
            }
            location.href = `/access?${params.toString()}`;
        } finally {
            this.sessionCheckRunning = false;
        }
    }

    private redirectForRequiredPasswordChange() {
        if (!this.service.auth.session?.must_change_password || location.pathname === '/mypage') {
            return false;
        }
        location.href = '/mypage?forcePasswordChange=1#password-change';
        return true;
    }
}

export default LayoutSidebarComponent;